define('settings/lib/setSale-analytics/set-sale-analytics',['require','knockout','durandal/app','api-access','mixpanel-helper'],function (require) {
    var ko = require('knockout');
    var app = require('durandal/app');
    var userApi = require('api-access').user;
    var mixpanelHelper = require('mixpanel-helper');

    return function () {
        var self = this;

        self.isAnalyticsSelected = ko.observable();
        self.originalAnalyticsSelection = ko.observable();
        self.isEmailEnabled = ko.observable();
        self.originalEmailSelection = ko.observable();

        self.shouldShowSave = ko.computed(function () {
            return self.isAnalyticsSelected() !== self.originalAnalyticsSelection() ||
              self.isEmailEnabled() !== self.originalEmailSelection();
        });

        function getEmailPreference(isEmailEnabled) {
            return {daily: isEmailEnabled};
        }

        function getInitialValue(setsaleEmailPreferences) {
            if (setsaleEmailPreferences) {
                return JSON.parse(setsaleEmailPreferences).daily;
            }
            return true;
        }

        self.save = function () {
            var isAnalyticsSelected = self.isAnalyticsSelected();
            var isEmailEnabled = self.isEmailEnabled();

            userApi
                .updateSettings({
                    setSaleEnabled: isAnalyticsSelected,
                    setSaleEntitled: isAnalyticsSelected,
                    setsaleEmailPreferences: JSON.stringify(getEmailPreference(isEmailEnabled))
                })
                .then(function () {
                    app.trigger('settings:save');
                    self.originalAnalyticsSelection(isAnalyticsSelected);
                    self.originalEmailSelection(isEmailEnabled);
                })
                .fail(function () {
                    self.cancel();
                });

            if (isAnalyticsSelected) {
                mixpanelHelper.track('Activate Analytics');
            } else {
                mixpanelHelper.track('Deactivate Analytics');
            }
        };

        self.cancel = function () {
            self.isAnalyticsSelected(self.originalAnalyticsSelection());
            self.isEmailEnabled(self.originalEmailSelection());
        };

        self.activate = function () {
            return userApi.settings()
                .then(function (userSettings) {
                    self.isAnalyticsSelected(userSettings.setSaleEnabled);
                    self.originalAnalyticsSelection(userSettings.setSaleEnabled);
                    self.isEmailEnabled(getInitialValue(userSettings.setsaleEmailPreferences));
                    self.originalEmailSelection(getInitialValue(userSettings.setsaleEmailPreferences));
                });
        };
    };
});

